import React from 'react';

const Logo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: "h-8",
    md: "h-10 md:h-12", 
    lg: "h-14 md:h-16",
    xl: "h-16 md:h-20"
  };
  return (
    <img 
      src="/ultraflex-logo.png" 
      alt="UltraFlex" 
      className={`${sizes[size]} ${className}`}
    />
  );
};

export default Logo;
